import IconsWithDescription from './IconsWithDescription'

export default IconsWithDescription
